import AgentLeftSection from 'components/AgentLeftSection/AgentLeftSection'
import AgentRightSection from 'components/AgentRightSection/AgentRightSection'
import Layout from 'components/Layout/Layout'
import React, { Component } from 'react'
import { Col } from "react-bootstrap";
import "./Dashboard.scss";
import { getUser, getUsername, getToken, getGroup } from "utils/Common";
import { UserGroup } from 'constants/UserConstants';
import { uepClient, getBaseURL, cvFleetEdgeWebsocketApiBaseURL } from "uepClient";
import StompClient from "components/Dashboard/StompClient";
import { connect } from "react-redux";
import { agentBackGroundMessageCount } from "actions/agentSocketActions";
import { ReceiveMessageService, SendMessageService } from 'services/MessageService';
import { AgentTabView } from 'constants/ChatViewConstants';
import WithAlert from 'hoc/WithAlert';
export class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.group = getGroup();
    this.currentAgentId = getUsername();
  }

  componentDidMount() {
    this.initializeChatSocketAndSubscribe();
    SendMessageService.listen().subscribe(this.onSendNewMessage);
  }

  componentWillUnmount() {
    this.stompClient.disconnect();
  }

  initializeChatSocketAndSubscribe = () => {
    let CHAT_SOCKET_URL = this.getWebsocketApiUrl();
    this.stompClient = new StompClient(CHAT_SOCKET_URL);
    this.stompClient.connect(
      { Authentication: getToken() },
      this.onSocketConnected,
      this.onSocketError
    );
  };

  getWebsocketApiUrl = () => {
    const group = getGroup();
    let baseUrl;
    if (UserGroup.FLEET_EDGE === group) {
      baseUrl = cvFleetEdgeWebsocketApiBaseURL;
    }
    else {
      baseUrl = getBaseURL();
    }
    return `${baseUrl}/chatWS`;
  };

  onSocketConnected = () => {
    const { currentAgentId } = this;
    this.stompClient.subscribe(
      `/user/${currentAgentId}/queue/messages`,
      this.onMessageReceived
    );
  };
  onMessageReceived = (msg) => {
    console.log("onMessageReceived msg", msg)
    if (this.props.agentTab.section == AgentTabView.AGENT_CHAT) {
      ReceiveMessageService.receive(msg);
    } else {
      const count = this.props.agentBgMsgCount.count + 1
      this.props.agentBackGroundMessageCount(count)
    }
  }
  onSocketError = () => {
    this.props.showAlert({
      variant: "danger",
      content: (
        <span>
          <b>Error! </b> Something went wrong, please refresh the page.
        </span>
      ),
    });
  };

  onSendNewMessage = (message) => {
    /*
      Message structure to be of:
      {
        conversationId:"c123",
        "phoneNumber:9034234234"
        "agentId":"ap_532865",
        "message":"Hello, from agent"
      }
     */
    // Adding a new message as agent
    this.stompClient.send("/chat-service/chat", message);
  };

  render() {
    return (

      <Layout className="dashboard-page">
        <div className="dashboard main-section">
          {this.group == UserGroup.FLEET_EDGE ?
            <Col className="AgentLeftSection">
              <AgentLeftSection />
            </Col>
            :
            null}
          <Col className="AgentRightSection">
            <AgentRightSection />
          </Col>
        </div>
      </Layout>

    )
  }
}

const mapStateToProps = (state) => ({
  agentTab: state.agentTab,
  agentBgMsgCount: state.agentBgMsgCount
});
const mapDispatchToProps = {
  agentBackGroundMessageCount,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WithAlert(Dashboard));
